import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useEmployeeId, useToken } from "../../../Utility/StoreData";
import { viewReports } from "../../../Services/Services";
import { Loader } from "../../../Components";
import FinalInspectionReport from "./Finalinspectionreport";
import SettingInspectionReport from "./Settingapprovalreport";
import LineInspectionReport from "./LineInspectionReport";
import Emptypage from "./Incominginspectionreport";
import { getCatchMsg } from "../../../Utility/GeneralUtils";

function ViewReports() {
  const token = useToken();
  const userId = useEmployeeId();
  const { state } = useLocation();
  const [loader, setloader] = useState(false);
  const [reportList, setReportList] = useState();

  const handleGetViewReport = (data) => {
    setloader(true);
    let formData = new FormData();
    formData.append("token", token);
    formData.append("user_id", userId);
    formData.append("process_id", data?.process_id);
    formData.append("product_id", data?.product_id);
    formData.append("report_id", data?.report_id);
    formData.append("report_type", data?.report_type);
    viewReports(formData)
      .then((response) => {
        if (response?.data?.status === 1) {
          setReportList(response?.data?.data);
        }
      })
      .catch((err) => {
        getCatchMsg(err);
      })
      .finally(() => setloader(false));
  };

  const getReportPage = () => {
    if (state?.report_type === 1) {
      return <Emptypage viewReportData={reportList} />;
    } else if (state?.report_type === 2) {
      return <SettingInspectionReport viewReportData={reportList} />;
    } else if (state?.report_type === 3) {
      return <LineInspectionReport viewReportData={reportList} />;
    } else if (state?.report_type === 4) {
      return <FinalInspectionReport viewReportData={reportList} />;
    }
  };

  useEffect(() => {
    if ((state, token)) handleGetViewReport(state);
  }, [state, token]);

  return (
    <div>
      {loader ? <Loader /> : null}
      {reportList && getReportPage()}
    </div>
  );
}

export default ViewReports;
